module.exports = __webpack_public_path__ + "static/media/executionerSound1.4e30a209.mp3";